import Vue from "vue";
import Vuetify from "vuetify/lib";

Vue.use(Vuetify);

export default new Vuetify({
  theme: {
    themes: {
      light: {
        primary: "#9ABE23",
        secondary: "#9ABE23",
        accent: "#9ABE23",
      },
    },
  },
});
